import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Penjualan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Penjualan',
        href: '/adm/sales',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_sales',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'tgl_jual',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'code_jual',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'dist_name',
        label: 'Distributor',
        sortable: true,
      },
      {
        key: 'cust_name',
        label: 'Customer',
        sortable: true,
      },
      {
        key: 'total',
        label: 'Total',
      },
      {
        key: 'disc',
        label: 'Potongan',
      },
      {
        key: 'total_final',
        label: 'Total Final',
      },
      {
        key: 'status_pay',
        label: 'Pembayaran',
      },
      {
        key: 'status_sale',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {},
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  detail(state) {
    return state.data.detail;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeSales(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchSales(context, params = null) {
    let result = await ApiGetRequest(`sales`, params);
    return !result.error ? result.data.object : [];
  },

  async getListSales({ commit, state }, payload = {}) {
    commit('changeSales', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_distributor: data.id_distributor ? data.id_distributor : '',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`sales`, params);
      commit('changeSales', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_sales.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`sales`, params);
      commit('changeSales', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailSales({ commit }, payload = null) {
    commit('changeSales', {
      loading: true,
    });

    let result = await ApiGetRequest(`sales/${payload.id}`);
    commit('changeSales', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadImageSales({ commit, state }, payload) {
    commit('changeSales', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeSales', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSales', {
        form: {
          ...data.form,
          prod_img: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeSales', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`sales/import`, {
      items: data.import_form || [],
    });

    commit('changeSales', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createSales({ commit, state, dispatch }) {
    commit('changeSales', {
      loading: true,
    });

    let result = await ApiPostRequest(`sales`, state.data.form);
    commit('changeSales', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSales({ commit, state, dispatch }, payload = null) {
    commit('changeSales', {
      loading: true,
    });

    let result = await ApiPutRequest(`sales/${payload.id}`, state.data.form);

    commit('changeSales', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSales({ commit, dispatch }, payload = null) {
    commit('changeSales', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`sales/${payload.id}`);
    commit('changeSales', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
